import React from 'react';
import ReactDOM from 'react-dom/client';
import { useForm, ValidationError } from '@formspree/react';
import './index.css';

function Feedback() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [feedback, setFeedback] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [state, handleSubmit] = useForm('xljrazrj');
  const subject = feedback.trim().split('\n')[0];

  React.useEffect(() => {
    let cancelled = false;
    fetch('https://ipapi.co/json/')
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        if (cancelled) return;
        const parts = [data.city, data.region, data.country_name].filter(Boolean);
        const coords = data.latitude && data.longitude ? ` (${data.latitude}, ${data.longitude})` : '';
        setLocation(parts.length ? `${parts.join(', ')}${coords}` : 'unknown');
      })
      .catch(() => {
        if (!cancelled) setLocation('unavailable');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const onSubmit = (event) => {
    event.preventDefault();
    handleSubmit({
      _subject: subject,
      message: `${feedback}\n\n---\nLocation: ${location || 'unavailable'}`,
    });
  };

  return (
    <div className="feedback">
      <button
        className="feedback__toggle"
        type="button"
        aria-expanded={isOpen}
        aria-controls="feedback-form"
        onClick={() => setIsOpen((open) => !open)}
      >
        Give feedback
      </button>

      {isOpen && (
        <form id="feedback-form" className="feedback__form" onSubmit={onSubmit}>
          {state.succeeded ? (
            <p className="feedback__status" role="status">
              Thanks, your feedback was sent.
            </p>
          ) : (
            <>
              <label className="feedback__label" htmlFor="feedback-message">
                Feedback
              </label>
              <input type="hidden" name="_subject" value={subject} />
              <textarea
                id="feedback-message"
                name="message"
                value={feedback}
                onChange={(event) => setFeedback(event.target.value)}
                placeholder="enter your subject and then any text after"
                rows="8"
                required
                autoFocus
              />
              <ValidationError
                className="feedback__error"
                field="message"
                prefix="Feedback"
                errors={state.errors}
              />
              <button className="feedback__send" type="submit" disabled={state.submitting}>
                {state.submitting ? 'Sending…' : 'Send feedback'}
              </button>
            </>
          )}
        </form>
      )}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <main className="center">
      <p className="font">Pooping soon...</p>
      <Feedback />
    </main>
  </React.StrictMode>
);

